import styled from 'styled-components';

const Group = styled.div`
  display: flex;
  overflow: hidden;
`;

const RightDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: var(--space-0) auto;
  overflow: hidden;
  position: relative;
`;
export { Group, RightDiv };
